import * as React from 'react';

import { angularProviderHOC } from '../../../common/react/AngularProviderHOC';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';
import { LicensesService } from '../../../ts/services/LicensesService';
import { getSessionManagementServiceInstance, SessionManagementService } from '../../../sessionManagement/SessionManagementService';
import { SiteAuthenticationSettingsService } from '../../../ts/services/SiteAuthenticationSettingsService';
import { ServiceLocator } from '../../ServiceLocator';
import { SpaceInfo, SpaceItemForNonEntitySpace } from '../../state/SpaceInfo';
import { ConnectedQueryParamUpdateProvider } from '../RouterHelpers/QueryParamUpdateProvider';
import { ConnectedSpaceInfoProvider } from '../RouterHelpers/SpaceInfoProvider';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { AllSiteUsersAngularProps, AllSiteUsersSpaceOwnProps } from './AllSiteUsersSpace';
import { ConnectedAllSiteUsersSpace } from './ConnectedAllSiteUsersSpace';

const AllSiteUsersSpaceAngularHOC = angularProviderHOC<AllSiteUsersSpaceOwnProps, AllSiteUsersAngularProps, AllSiteUsersAngularProps>({
  getAngularServicesWithServiceLocator: () => ({
    licensesService: ServiceLocator.get<LicensesService>('LicensesService'),
    siteAuthSettingsService: ServiceLocator.get<SiteAuthenticationSettingsService>('SiteAuthenticationSettingsService'),
    serverService: getSessionManagementServiceInstance()
  }),
  selectPropsFromAngularServices: angularServices => angularServices,
});

const AngularWrappedAllSiteUsersSpace: React.ComponentType<AllSiteUsersSpaceOwnProps>
  = AllSiteUsersSpaceAngularHOC(ConnectedAllSiteUsersSpace);

export interface AllSiteUsersSpaceProviderProps extends ReactDirectiveProps {
  readonly routeLocationPath: string;
  readonly routeLocationSearch: string;
  readonly siteName: string;
  readonly urls: SpacesSiteUrls;
}

const AllSiteUsersSpaceInfo: SpaceInfo = {
  item: SpaceItemForNonEntitySpace,
  spaceType: 'siteusers',
  subspaceName: undefined
};

export const AllSiteUsersSpaceProvider: React.FunctionComponent<AllSiteUsersSpaceProviderProps> = (props) => {
  return (
    <ConnectedSpaceInfoProvider spaceInfo={AllSiteUsersSpaceInfo}>
      <ConnectedQueryParamUpdateProvider
        routeLocationPath={props.routeLocationPath}
        routeLocationSearch={props.routeLocationSearch}
        shouldUpdateBreadcrumbs={true}
        shouldUpdateContentTypes={false}
        shouldUpdateFilters={true}
        shouldUpdateSort={true}
      >
        <AngularWrappedAllSiteUsersSpace
          angularContext={props.angularContext}
          siteName={props.siteName}
          urls={props.urls}/>
      </ConnectedQueryParamUpdateProvider>
    </ConnectedSpaceInfoProvider>
  );
};
